// src/design/forms/datepicker/calendar-carburettor/constants/index.ts
var e = 2033, t = 1943, n = 2090, r = 2e3;
export { e as MAX_ENG_YEAR, n as MAX_NEP_YEAR, t as MIN_ENG_YEAR, r as MIN_NEP_YEAR };

//# sourceMappingURL=index.js.map